import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'wip/policies/policy',
    pathMatch: 'full'
  },
  {
    path: 'wip',
    redirectTo: 'wip/policies/policy',
    pathMatch: 'full'
  },
  {
    path: 'wip/policies',
    redirectTo: 'wip/policies/policy',
    pathMatch: 'full'
  },
  {
    path: '',
    // TODO: Routeguard from login
    // Also TODO: WTF is this
    component: HomeComponent,
    children: [
      {
        path: 'wip',
        component: DashboardComponent,
        children: [
          {
            path: 'policies',
            loadChildren: () => import('../policy/policy.module').then(m => m.PolicyModule)
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
